/* tslint:disable */
/* eslint-disable */
/**
 * Oil refinery process modeling system
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.2.4
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {mapValues} from '../runtime';
import type {ElementEdgeProperties} from './ElementEdgeProperties';
import {
  ElementEdgePropertiesFromJSON,
  ElementEdgePropertiesFromJSONTyped,
  ElementEdgePropertiesToJSON
} from './ElementEdgeProperties';
import type {Target} from './Target';
import {TargetFromJSON, TargetFromJSONTyped, TargetToJSON} from './Target';
import type {EnergyFlowEdgeProperties} from './EnergyFlowEdgeProperties';
import {
  EnergyFlowEdgePropertiesFromJSON,
  EnergyFlowEdgePropertiesFromJSONTyped,
  EnergyFlowEdgePropertiesToJSON
} from './EnergyFlowEdgeProperties';
import type {MaterialFlowEdgeProperties} from './MaterialFlowEdgeProperties';
import {
  MaterialFlowEdgePropertiesFromJSON,
  MaterialFlowEdgePropertiesFromJSONTyped,
  MaterialFlowEdgePropertiesToJSON
} from './MaterialFlowEdgeProperties';
import type {LogicalFlowEdgeProperties} from './LogicalFlowEdgeProperties';
import {
  LogicalFlowEdgePropertiesFromJSON,
  LogicalFlowEdgePropertiesFromJSONTyped,
  LogicalFlowEdgePropertiesToJSON
} from './LogicalFlowEdgeProperties';
import type {EdgeType} from './EdgeType';
import {EdgeTypeFromJSON, EdgeTypeFromJSONTyped, EdgeTypeToJSON} from './EdgeType';
import type {Source} from './Source';
import {SourceFromJSON, SourceFromJSONTyped, SourceToJSON} from './Source';

/**
 *
 * @export
 * @interface EdgesInner
 */
export interface EdgesInner {
  /**
   *
   * @type {string}
   * @memberof EdgesInner
   */
  id: string;
  /**
   *
   * @type {Source}
   * @memberof EdgesInner
   */
  source: Source;
  /**
   *
   * @type {Target}
   * @memberof EdgesInner
   */
  target: Target;
  /**
   *
   * @type {EdgeType}
   * @memberof EdgesInner
   */
  type: EdgeType;
  /**
   *
   * @type {string}
   * @memberof EdgesInner
   */
  sourceHandle?: string | null;
  /**
   *
   * @type {string}
   * @memberof EdgesInner
   */
  targetHandle?: string | null;
  /**
   *
   * @type {boolean}
   * @memberof EdgesInner
   */
  reconnectable?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof EdgesInner
   */
  deletable?: boolean;
  /**
   *
   * @type {object}
   * @memberof EdgesInner
   */
  style?: object | null;
  /**
   *
   * @type {string}
   * @memberof EdgesInner
   */
  sourceHandleQualifier?: string | null;
  /**
   *
   * @type {string}
   * @memberof EdgesInner
   */
  targetHandleQualifier?: string | null;
}

/**
 * Check if a given object implements the EdgesInner interface.
 */
export function instanceOfEdgesInner(value: object): value is EdgesInner {
  if (!('id' in value) || value['id'] === undefined) return false;
  if (!('source' in value) || value['source'] === undefined) return false;
  if (!('target' in value) || value['target'] === undefined) return false;
  if (!('type' in value) || value['type'] === undefined) return false;
  return true;
}

export function EdgesInnerFromJSON(json: any): EdgesInner {
  return EdgesInnerFromJSONTyped(json, false);
}

export function EdgesInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): EdgesInner {
  if (json == null) {
    return json;
  }
  return {
    id: json['id'],
    source: SourceFromJSON(json['source']),
    target: TargetFromJSON(json['target']),
    type: EdgeTypeFromJSON(json['type']),
    sourceHandle: json['sourceHandle'] == null ? undefined : json['sourceHandle'],
    targetHandle: json['targetHandle'] == null ? undefined : json['targetHandle'],
    reconnectable: json['reconnectable'] == null ? undefined : json['reconnectable'],
    deletable: json['deletable'] == null ? undefined : json['deletable'],
    style: json['style'] == null ? undefined : json['style'],
    sourceHandleQualifier:
      json['sourceHandleQualifier'] == null ? undefined : json['sourceHandleQualifier'],
    targetHandleQualifier:
      json['targetHandleQualifier'] == null ? undefined : json['targetHandleQualifier']
  };
}

export function EdgesInnerToJSON(value?: EdgesInner | null): any {
  if (value == null) {
    return value;
  }
  return {
    id: value['id'],
    source: SourceToJSON(value['source']),
    target: TargetToJSON(value['target']),
    type: EdgeTypeToJSON(value['type']),
    sourceHandle: value['sourceHandle'],
    targetHandle: value['targetHandle'],
    reconnectable: value['reconnectable'],
    deletable: value['deletable'],
    style: value['style'],
    sourceHandleQualifier: value['sourceHandleQualifier'],
    targetHandleQualifier: value['targetHandleQualifier']
  };
}
